export default __webpack_public_path__ + "static/media/logo_enashopp.e1d86a55.svg";